import { getUserInitials } from "@/app/utils/get-user-initials";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

type EventOrganiserProps = {
  firstName: string;
  lastName: string;
  avatarURL?: string;
  showHostedBy?: boolean;
  email?: string;
};

export function EventOrganiser({
  firstName,
  lastName,
  avatarURL,
  showHostedBy = true,
  email,
}: EventOrganiserProps) {
  const hostedBy = `${firstName} ${lastName}`;
  const hostInitials = getUserInitials(firstName, lastName);
  return (
    <div className="flex items-center gap-2">
      <Avatar>
        <AvatarImage src={avatarURL} />
        <AvatarFallback className="bg-border capitalize text-muted">
          {hostInitials}
        </AvatarFallback>
      </Avatar>
      <div className="flex min-w-0 flex-1 flex-col">
        {showHostedBy && <p className="text-sm text-muted">Hosted by</p>}
        <p className="truncate text-sm font-medium text-foreground">
          {hostedBy}
        </p>
        {email && (
          <p className="truncate text-xs text-muted-foreground">{email}</p>
        )}
      </div>
    </div>
  );
}
